/**
 * Temporary click/write tracing for debugging stuck UI after login.
 * Remove after root cause is confirmed.
 */

import { devLog } from './utils/logger';

const PREFIX = '[DEV_CLICK_DEBUG]';

export function isDevClickDebugEnabled() {
  return process.env.NODE_ENV === 'development';
}

/** @param {string} message @param {unknown} [payload] */
export function devClickDebug(message, payload) {
  if (!isDevClickDebugEnabled()) return;
  if (payload !== undefined) {
    devLog(`${PREFIX} ${message}`, payload);
  } else {
    devLog(`${PREFIX} ${message}`);
  }
}

/**
 * Capture-phase global click logger (noisy). Opt-in: `localStorage.setItem('DEVELLO_GLOBAL_CLICK_DEBUG','1')` + reload.
 */
export function installDevGlobalClickDebug() {
  if (!isDevClickDebugEnabled()) return () => {};
  const handler = (e) => {
    devLog(`${PREFIX} global click target:`, e.target);
  };
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}
